.switcherRow { display: flex; align-items: center; gap: 16px; }
/* Two classes: ToggleTabs' own .option padding loads after this module. */
.switcher :global(button) { height: 44px; padding: 0 20px; gap: 8px; }
.switcherHint { font-family: var(--font-mono); font-size: 9px; letter-spacing: 1px; color: var(--text-secondary); }
.hrCard { width: 100%; }
.cardNote { margin: 0; padding: 14px 24px 18px; font-size: 12px; line-height: 1.45; color: var(--text-secondary); }
.zonesWrap { display: flex; flex-direction: column; gap: 8px; padding: 18px 24px 0; }
.zonesTitle { margin: 0; font-family: var(--font-mono); font-size: 9px; letter-spacing: 1.2px; color: var(--text-secondary); }
.zoneStrip { display: flex; height: 24px; margin: 0; padding: 0; list-style: none; border: 1px solid var(--ink); }
.zoneStrip li { flex: 1; display: flex; align-items: center; justify-content: center; font-family: var(--font-mono); font-size: 8px; color: var(--ink); white-space: nowrap; }
.maxHrShared { display: flex; align-items: flex-start; gap: 10px; padding: 10px 12px; border: var(--border-hair); }
.maxHrLine { margin: 0 0 4px; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; }
.appliesTo { display: flex; align-items: center; gap: 8px; padding: 12px 24px; border-bottom: var(--border-hair); }
.appliesLabel { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.2px; color: var(--text-secondary); }
.tags { display: flex; flex-wrap: wrap; gap: 8px; margin: 0; padding: 0; list-style: none; }
.maxHrValueRow { display: flex; align-items: center; gap: 10px; margin: 0; }
.sharedChip { display: inline-flex; align-items: center; gap: 5px; padding: 3px 7px; border: 1px solid var(--ink); font-family: var(--font-mono); font-size: 9px; letter-spacing: 1px; }
/* Two classes: .btn's padding loads after this module. */
:global(.btn).editUnderRide { height: 44px; padding: 0 16px; gap: 8px; }

@media (max-width: 639px) {
  .switcherRow { flex-direction: column; align-items: stretch; }
  .switcher :global(button) { padding: 0; gap: 6px; font-size: 10px; letter-spacing: 0.8px; }
  .zonesWrap, .zonesTitle { display: none; }
}
